import { render } from "./ControlsDialog.vue?vue&type=template&id=22687200&scoped=true&ts=true"
import script from "./ControlsDialog.vue?vue&type=script&lang=ts"
export * from "./ControlsDialog.vue?vue&type=script&lang=ts"

import "./ControlsDialog.vue?vue&type=style&index=0&id=22687200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22687200"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
